import { useSelector } from 'react-redux';
import * as SMSLogService from 'services/messaging/logs/sms';

export const useSMSLogService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchSMSLogs = async (options = {}) => {
    const { error, payload } = await SMSLogService.read({ ...options, token });
    if (error) {
      return {
        logs: [],
        size: 0
      };
    }

    const {
      data: logs,
      meta: { size }
    } = payload;
    return { logs, size };
  };

  const searchSMSLogs = async (keys, keyword, options = {}) => {
    const { error, payload } = await SMSLogService.search(keys, keyword, { ...options, token });
    if (error) {
      return { logs: [], size: 0 };
    }

    const {
      data: logs,
      meta: { size }
    } = payload;
    return { logs, size };
  };

  return { fetchSMSLogs, searchSMSLogs };
};
